import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

import { fontFamilySecondary } from "../../shared/styles";

export const lensCtaIcon = css`
    position: absolute;
    right: 0;
    bottom: 60px;
    left: 0;

    margin: auto;
`;

export const videoPreview = css`
    position: absolute;
    bottom: 0;
    left: 0;
    border-radius: 6px;
`;

export const PreviewViewer = styled.div`
    position: relative;

    overflow: hidden;

    width: 230px;
    height: 230px;

    background: ${Colors.Gray.V50};
    border-radius: 24px;
`;

export const ImagePreview = styled.img`
    position: absolute;
    bottom: 0;
    left: 0;

    width: 100%;

    border-radius: 6px;
`;

export const ARBarPreview = styled.img`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
`;

export const CTAPreview = styled.div`
    position: absolute;
    right: 0;
    bottom: 120px;
    left: 0;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    margin: auto;

    span {
        ${fontFamilySecondary};
        padding: 3.5px 10px;

        font-size: 13px;
        font-weight: 500;
        line-height: 20px;
        color: #2c3137;

        background-color: #eceff1;
        border-radius: 32px;
    }
`;
